import { EntityDefinition } from '../types/entity-definition.interface';
import { MeasureChecker } from '../types/measure-checker.interface';

export const measureCheckerDefinition: EntityDefinition<MeasureChecker> = {
  entityType: 'MeasureChecker',
  i18nBase: 'entities.measureChecker',
  list: {
    columns: [
      { field: 'startTs', headerKey: 'entities.measureChecker.fields.startTs', sortable: true, template: 'date' },
      { field: 'endTs', headerKey: 'entities.measureChecker.fields.endTs', sortable: true, template: 'date' },
      { field: 'type', headerKey: 'entities.measureChecker.fields.type', sortable: true },
    ],
  },
  validationRules: [],
  actionButtons: {
    parent: {
      add: true,
      edit: true,
    },
  },
  messages: {
    dialogTitles: {
      create: () => 'entities.measureChecker.messages.createTitle',
      edit: () => 'entities.measureChecker.messages.editTitleWithName',
      delete: () => 'entities.measureChecker.messages.deleteTitleWithName',
    },
    buttons: {
      add: () => 'entities.measureChecker.messages.addButton',
      create: () => 'entities.measureChecker.messages.addButton',
      edit: () => 'entities.measureChecker.messages.editTitleWithName',
      delete: () => 'entities.measureChecker.messages.deleteTitle',
    },
    confirmDelete: () => 'entities.measureChecker.messages.deleteConfirm',
  },
};
